import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { IntroducingBrokerProfileKey } from 'api/Trading-Accounts/Types/IntroducingBrokerProfileDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const introducingBrokerProfilesColumn: GridColumn[] = [
  {
    title: 'Description',
    field: IntroducingBrokerProfileKey.description,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Entity',
    field: IntroducingBrokerProfileKey.tickmillCompany,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td className='table-columns__content'>
          <CompanyTag id={props.dataItem.tickmillCompany.id}>
            {props.dataItem.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
]

export default introducingBrokerProfilesColumn
